import React from 'react';
import Button, { ButtonsHolder } from '../../../partials/Button';
import HTMLContent from '../../../partials/HTMLContent';
import Scroll from '../../../partials/Scroll/Scroll';
import styles from "./ConversationBubble.module.scss"

const ConversationBubble =  ({text, button, position, onContinue}) => {

    const positionStyle = (position) => {

        switch (position) {
            default: return ''; break;
            case 'left': return styles.left; break;
            case 'right': return styles.right; break;
            case 'top': return styles.top; break;
            case 'bottom': return styles.bottom; break;
        }
    }
    const sizeStyle = (length)  => {

        if(length >= 0 && length <= 99) return styles.small;
        if(length >= 100 && length <= 249) return styles.medium;
        if(length >= 250 && length <= 500) return styles.large;

    }
    return (
        <div className={`${styles.bubble} ${positionStyle(position)} ${sizeStyle(text.length)}`}>
            
            <Scroll>
                <HTMLContent className={styles.content} html={text} />
            </Scroll>

            {onContinue && <ButtonsHolder variant="row" orientation="right" >
                <Button variant="link" text={button} onClick={onContinue} />
            </ButtonsHolder>}


            
        </div>

    )


}

export default ConversationBubble;